import { PaymentMethod } from '../../../../../services/exports/Constants';

export default {
  payment_methods: {
    [PaymentMethod.Card]: 'Creditcard',
    [PaymentMethod.Sofort]: 'Sofort',
    [PaymentMethod.Giropay]: 'Giropay',
    [PaymentMethod.PayByBank]: 'Betalen via bank',
    [PaymentMethod.SepaDebit]: 'EC-kaart / IBAN',
    [PaymentMethod.Cash]: 'Contant',
    [PaymentMethod.Link]: 'Link',
    [PaymentMethod.StripeOther]: 'Andere betaalmethode',
  },
};
